import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { COMPANY } from "@/i18n";
import { Reveal, MaskLines } from "./Reveal";

export const Gallery = () => {
  const { t } = useLang();
  const g = t.gallery;
  const p = COMPANY.photos;

  const items = [
    { src: p.exterior, cap: g.captions.exterior, span: "md:col-span-7", h: "h-[300px] sm:h-[440px]", n: "01" },
    { src: p.milka, cap: g.captions.milka, span: "md:col-span-5", h: "h-[300px] sm:h-[440px]", n: "02" },
    { src: p.aisle, cap: g.captions.aisle, span: "md:col-span-5", h: "h-[280px] sm:h-[340px]", n: "03" },
    { src: p.shelves, cap: g.captions.shelves, span: "md:col-span-3", h: "h-[280px] sm:h-[340px]", n: "04" },
    { src: p.warehouseRoom, cap: g.captions.warehouseRoom, span: "md:col-span-4", h: "h-[280px] sm:h-[340px]", n: "05" },
  ];

  return (
    <section id="gallery" data-testid="gallery-section" className="relative py-24 sm:py-32">
      <div className="spot-glow w-[400px] h-[400px] bg-[#D4AF37]/10 top-40 -right-20" />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-xs sm:text-sm uppercase tracking-[0.25em] text-[#D4AF37] mb-6">
            {g.overline}
          </p>
        </Reveal>
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <h2 className="font-display font-medium tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[1.02] max-w-2xl text-white">
            <MaskLines lines={[g.title]} />
          </h2>
          <Reveal delay={0.15}>
            <p className="text-zinc-400 max-w-sm lg:text-right">{g.lead}</p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 sm:gap-5">
          {items.map((it, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08} className={it.span}>
              <div
                data-testid={`gallery-item-${i}`}
                className={`group relative ${it.h} rounded-2xl overflow-hidden border border-white/10 hover:border-[#D4AF37]/50 transition-colors`}
              >
                <motion.img
                  src={it.src}
                  alt={it.cap}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.06]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/15 to-transparent opacity-90 group-hover:opacity-100 transition-opacity" />
                <span className="absolute top-4 left-4 font-mono text-xs text-[#D4AF37]/90 bg-black/40 backdrop-blur px-2.5 py-1 rounded-full border border-white/10">
                  {it.n}
                </span>
                <div className="absolute bottom-0 left-0 right-0 p-5 sm:p-6">
                  <div className="h-px w-8 bg-[#D4AF37] mb-3 group-hover:w-14 transition-all duration-500" />
                  <p className="font-display text-lg sm:text-xl font-semibold text-white">{it.cap}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
